import { QuoteRequest } from "../types/rate-analysis";

/**
 * Determines if a quote request should be treated as a RefiBuddy refinance request
 *
 * A quote request is considered RefiBuddy if:
 * - It has a current mortgage with a rate (indicating it's a refinance)
 * - It has an email address (for notifications)
 *
 * @param quoteRequest - The quote request to evaluate
 * @returns true if this is a RefiBuddy refinance request, false otherwise
 */
export const isRefiBuddyRequest = (
  quoteRequest: QuoteRequest | undefined
): boolean => {
  if (!quoteRequest) return false;

  return !!(quoteRequest.current_mortgage?.rate && quoteRequest.email);
};

/**
 * Determines if a quote request is for a refinance loan
 *
 * @param quoteRequest - The quote request to evaluate
 * @returns true if this is a refinance request, false if it's a purchase
 */
export const isRefinanceRequest = (
  quoteRequest: QuoteRequest | undefined
): boolean => {
  if (!quoteRequest) return false;

  return quoteRequest.loan_type === "refinance";
};

/**
 * Determines if a quote request is for a purchase loan
 *
 * @param quoteRequest - The quote request to evaluate
 * @returns true if this is a purchase request, false if it's a refinance
 */
export const isPurchaseRequest = (
  quoteRequest: QuoteRequest | undefined
): boolean => {
  if (!quoteRequest) return false;

  return quoteRequest.loan_type === "purchase";
};
